import React, { useState, useEffect } from "react";
import axios from "axios";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import { useRef, useCallback } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

export default function QrMobile() {
  // Remove sessionCode, use accessToken
  const [qrValue, setQrValue] = useState("");
  const [scanned, setScanned] = useState(false);
  const [status, setStatus] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    async function fetchConfig() {
      const config = await loadConfig();
      setApiUrl(config.APIURL);
      setLoadingConfig(false);
    }
    fetchConfig();
  }, []);

  // QR scanner using html5-qrcode with callback ref
  const html5QrRef = useRef(null);
  const qrReaderCallback = useCallback(node => {
    if (node && !scanned) {
      // Clean up previous scanner instance if exists
      if (html5QrRef.current) {
        html5QrRef.current.clear();
        html5QrRef.current = null;
      }
      html5QrRef.current = new Html5Qrcode(node.id);
      html5QrRef.current.start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: 250,
          formatsToSupport: [
            Html5QrcodeSupportedFormats.QR_CODE,
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.EAN_8,
            Html5QrcodeSupportedFormats.CODE_128,
            Html5QrcodeSupportedFormats.CODE_39,
            Html5QrcodeSupportedFormats.CODE_93,
            Html5QrcodeSupportedFormats.ITF,
            Html5QrcodeSupportedFormats.UPC_A,
            Html5QrcodeSupportedFormats.UPC_E
          ]
        },
        qrCodeMessage => {
          setQrValue(qrCodeMessage);
          setScanned(true);
          html5QrRef.current.stop().catch(() => {});
        },
        errorMessage => {
          setStatus("Fehler beim Zugriff auf die Kamera.");
        }
      );
    }
  }, [scanned]);

  useEffect(() => {
    return () => {
      if (html5QrRef.current) {
        html5QrRef.current.stop()
          .catch(() => {})
          .finally(() => {
            html5QrRef.current.clear();
            html5QrRef.current = null;
          });
      }
    };
  }, []);

  const handleSend = async () => {
    if (!qrValue) return;
    try {
      const accessToken = localStorage.getItem("accessToken");
      await axios.post(`${apiUrl}/qr-session`, { value: qrValue }, {
        headers: { accessToken }
      });
      setStatus("Erfolgreich gesendet!");
    } catch (err) {
      setStatus("Fehler beim Senden.");
    }
  };

  if (loadingConfig) {
    return <LoadingSpinner text="Lade Konfiguration..." />;
  }

  return (
    <div className="container">
      <h2>QR-Code / Barcode scannen & senden (Smartphone)</h2>
      {!scanned && (
        <div style={{ marginBottom: 20 }}>
          <div id="qr-reader" ref={qrReaderCallback} style={{ width: "100%" }} />
        </div>
      )}
      {qrValue && (
        <div style={{ marginTop: 20 }}>
          <div>Gescannt: <strong>{qrValue}</strong></div>
          <button className="btn btn-success" onClick={handleSend}>
            Senden
          </button>
          <button className="btn btn-secondary" style={{ marginLeft: 10 }} onClick={() => {
            setQrValue("");
            setScanned(false);
            setStatus("");
          }}>
            Scanner erneut öffnen
          </button>
        </div>
      )}
      {status && <div style={{ marginTop: 20, color: "green" }}>{status}</div>}
    </div>
  );
}
